<template>
  <div id="start">
    <img src="/static/logo_white.svg" class="logo" />
    <div class="input-block" v-if="$store.state.key == null">
      <el-input v-model="key" :size="'medium'" placeholder="Enter Key...">
        <template slot="append">
          <el-button :loading="loading" type="success" @click="start">Begin Test</el-button>
        </template>
      </el-input>
    </div>

    <div class="input-block" v-if="$store.state.key != null && $store.state.token == null">
      <CameraPhotoTake />
      <el-input v-model="form.firstName" :size="'medium'" placeholder="John">
        <template slot="prepend">
          <div style="width: 80px;">Name</div>
        </template>
      </el-input>
      <el-input v-model="form.lastName" :size="'medium'" placeholder="Doe" style="margin-top: 15px;">
        <template slot="prepend">
          <div style="width: 80px;">Surname</div>
        </template>
      </el-input>
      <el-input v-model="form.email" :size="'medium'" placeholder="name@domain.com" style="margin-top: 15px;">
        <template slot="prepend">
          <div style="width: 80px;">E-mail</div>
        </template>
      </el-input>
      <el-input v-model="form.phone" :size="'medium'" placeholder="555 555 55 55" v-mask="'+90 ### ### ## ##'"
        style="margin-top: 15px;">
        <template slot="prepend">
          <div style="width: 80px;">Phone</div>
        </template>
      </el-input>
      <div style="color: red;">
        {{
          validationErrors.some(k => k.key == "email")
          ? validationErrors.find(k => k.key == "email").value
          : ""
        }}
      </div>
      <el-input v-model="form.firm" readonly :size="'medium'" placeholder="isim@alanadi.com" style="margin-top: 15px;">
        <template slot="prepend">
          <div style="width: 80px;">Company</div>
        </template>
      </el-input>
      <el-input v-model="form.department" readonly :size="'medium'" placeholder="Departman" style="margin-top: 15px;">
        <template slot="prepend">
          <div style="width: 80px;">Department</div>
        </template>
      </el-input>
      <div class="checkbox-wrapper">
        <el-checkbox v-model="form.kvkk">I have read the nondisclosure text and I accept</el-checkbox>
        <el-button size="mini" @click="kvkkModal = true">
          <span class="xs">Read</span>
          <span class="sm">Click to read</span>
        </el-button>
      </div>
      <div class="checkbox-wrapper">
        <el-checkbox v-model="form.terms">I have read the confidentiality contract and I accept</el-checkbox>
        <el-button @click="termsModal = true" size="mini">
          <span class="xs">Read</span>
          <span class="sm">Click to read</span>
        </el-button>
      </div>

      <el-button style="float: right; margin-top: 20px" :loading="loading" @click="go">Continue ></el-button>
    </div>

    <div class="dialog-wrapper">
      <el-dialog :visible.sync="errorModalVisible" title="Camera Error">
        <div>
          <h1 style="text-align: center">
            <i class="el-icon-video-camera" style="font-size: 78px; color: red"></i>
          </h1>
          <h2 style="text-align: center; font-weight: 500; font-size: 20px">
            Camera permission required for begin exam.
            <span v-if="browser != null" style="font-size: 16px; font-weight: bold">
              <br />
              <a target="_blank"
                style="color: black; display: inline-block; padding: 5px 10px; border:1px solid #333; font-weight: 100; text-decoration: none; margin-top: 15px"
                :href="$helpLinks[browser]">
                for
                <strong>{{ browser }}</strong> check this link for help.
              </a>
            </span>
          </h2>
        </div>
      </el-dialog>

      <el-dialog :visible="dialogVisible" custom-class="info-modal" width="600px">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <h1 class="secondary-text" style="font-family: Arial">Notification</h1>
          <div style="font-weight: bold;
      color: black;
      line-height: 24px;">
            <p v-html="infoMessage"></p>
          </div>

          <el-button type="success" round @click="$router.push({ name: 'Interview' })">I understand. Begin</el-button>
        </div>
      </el-dialog>

      <el-dialog :visible="kvkkModal" custom-class="info-modal" width="800px">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <div v-html="kvkk" style="width: 100%;word-break: break-word;"></div>
          <div
            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
            <el-button round @click="kvkkModal = false; form.kvkk = false">Close</el-button>
            <el-button type="success" round @click="kvkkModal = false; form.kvkk = true">I understand. Accept</el-button>
          </div>
        </div>
      </el-dialog>

      <el-dialog :visible="termsModal" custom-class="info-modal" width="600px">
        <div style="display: flex; align-items: center; justify-content: center; flex-direction: column">
          <div v-html="terms" style="width: 100%;word-break: break-word;"></div>
          <div
            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
            <el-button round @click="termsModal = false; form.terms = false">Close</el-button>
            <el-button type="success" round @click="termsModal = false; form.terms = true">I understand.
              Accept</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CameraPhotoTake from "./CameraPhotoTake.vue";

export default {
  name: "Start",
  components: {
    CameraPhotoTake,
  },
  data() {
    return {
      loading: true,
      key: null,
      form: {
        firstName: '',
        lastName: '',
        email: '',
        kvkk: false,
        terms: false,
        firm: null,
        department: null,
        phone: '',
        phoneNumber: null,
        photo: null,
        // photo: "data:image/jpeg;base64,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…",
      },
      videoEl: null,
      canvas: null,
      errorModalVisible: false,
      browser: null,
      validationErrors: [],
      dialogVisible: false,
      infoMessage: null,
      examType: null,
      kvkk: null,
      terms: null,
      kvkkModal: false,
      termsModal: false
    };
  },
  beforeMount() {
    setTimeout(() => {
      this.loading = false;
    }, 0);

    axios
      .get(
        "https://ingilizcemulakat.com/tr/sozlesme/kvkk-aydinlatma-metni?popup=1"
      )
      .then(res => {
        this.kvkk = res.data;
      });

    axios
      .get(
        "https://ingilizcemulakat.com/tr/sozlesme/gizlilik-sozlesmesi?popup=1"
      )
      .then(res => {
        this.terms = res.data;
      });
  },
  methods: {
    openURL(url) {
      window.open(url);
    },
    start() {
      this.loading = true;
      axios
        .get("exam/checkaccesskey?accesskey=" + this.key)
        .then(res => {
          if (res.data.hasError) {
            this.$message.error(res.data.message);
          } else {
            this.$store.state.key = this.key;
            this.examType = res.data.data.exam.type;
            this.form.firm = res.data.data.firm.title;
            this.form.department = res.data.data.department.title;
            this.$store.state.firm = res.data.data.firm;
            this.$store.state.department = res.data.data.department;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          this.$message.error(err.toString());
        });
    },
    next() {
      if (this.form.kvkk == false || this.form.terms == false) {
        this.$message.error(
          "please read the nondisclosure and confidentiality text and accept"
        );
        return;
      }

      this.loading = true;

      var f = this.form;
      f.phoneNumber =
        this.form.phone != null
          ? this.form.phone
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
          : null;
      axios.post("exam/startexam?accesskey=" + this.key, f).then(res => {
        this.loading = false;
        if (res.data.hasError == false) {
          this.$store.commit("setSection", res.data.data.section);
          this.$store.state.nextSectionMessage =
            res.data.data.nextSectionMessage;
          this.$store.state.form.firstName = this.form.firstName;
          this.$store.state.form.lastName = this.form.lastName;
          this.$store.state.sectionInfos = res.data.data.sections;
          this.$store.state.exam = res.data.data.exam;
          if (res.data.data.exam.type == 2) {
            this.$store.state.currentSection = 5;
          }
          this.infoMessage = res.data.data.nextSectionMessage;
          this.dialogVisible = true;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    go() {
      if (this.examType == 2) {
        this.next();
        return;
      }
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then(stream => {
            this.next();
          })
          .catch(err => {
            if (err.toString().indexOf("Permission")) {
              this.browser = this.$checkBrowser();
              this.errorModalVisible = true;
            }
          });
      } else {
        this.browser = this.$checkBrowser();
        this.errorModalVisible = true;
      }
    }
  },
  computed: {
    photoData() {
      return this.$store.state.form.photo;
    }
  },
  watch: {
    photoData(newVal, oldVal) {
      if (newVal !== oldVal) {
        // console.log(newVal)
        this.form.photo = newVal;
      }
    },
    "form.kvkk": function (newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.kvkkModal = true;
      }
    },
    "form.terms": function (newVal, oldVal) {
      if (newVal == true && oldVal == false) {
        this.termsModal = true;
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Start.vue